export default __webpack_public_path__ + "1bdec198aabacb4d71f8fab481656ad7.svg";